import axios from "axios";
import config from "../config";
import { clearListPageFilters } from "./listPageStateStorage";

export const clearSessionData = () => {
  document.cookie.split(";").forEach((cookie) => {
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
    if (!name) return;
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
  });

  localStorage.clear();
  clearListPageFilters();
  delete axios.defaults.headers.common.Authorization;
};

/** Ruta absoluta del login, alineada con Router `basename`. */
export const getLoginUrl = () => {
  const base = (config.basename || "").replace(/\/$/, "");
  return `${base}/Account/Login`;
};
